import { observer } from 'owa-mobx-react';
import React from 'react';
import {
    Button,
    Divider,
    Field,
    Radio,
    RadioGroup,
    Title1,
    Title3,
} from '@fluentui/react-components';
import {
    getDevComponentState,
    getDevErrorPageState,
    getDevPageState,
} from '../store/explorePageDiagnosticsStoreGetters';
import {
    setExploreComponentState,
    setExploreErrorPageState,
    setExplorePageState,
} from '../utils/exploreStoreUtils';
import { container } from './PlacesExploreDiagnosticsPanel.scss';

import type { RadioGroupOnChangeData } from '@fluentui/react-components';
export const PlacesExploreDiagnosticsPanel: React.FunctionComponent = observer(() => {
    const onUXPageStateChange = React.useCallback(
        (_ev: React.FormEvent<HTMLDivElement>, data: RadioGroupOnChangeData) => {
            setExplorePageState(data.value);
        },
        []
    );

    const onUXPageComponentChange = React.useCallback(
        (_ev: React.FormEvent<HTMLDivElement>, data: RadioGroupOnChangeData) => {
            setExploreComponentState(data.value);
        },
        []
    );

    const onErrorPageStateChange = React.useCallback(
        (_ev: React.FormEvent<HTMLDivElement>, data: RadioGroupOnChangeData) => {
            setExploreErrorPageState(data.value);
        },
        []
    );

    const reload = React.useCallback(() => {
        window.location.reload();
    }, []);

    return (
        <div className={container}>
            <Title1>Explore Page Testing Helpers</Title1>
            <Title3>Explore UX Page State</Title3>
            <Field label="UX Page State">
                <RadioGroup onChange={onUXPageStateChange} value={getDevPageState()}>
                    <Radio
                        value="EmptyBuilding"
                        label="Empty building page (user has no building in FWH or Cache)"
                    />
                    <Radio value="EmptyTenant" label="No buildings in the tenant page" />
                    <Radio value="None" label="None" />
                </RadioGroup>
            </Field>
            <Divider />
            <Title3>Explore UX Page Components</Title3>
            <Field label="UX Page Components">
                <RadioGroup onChange={onUXPageComponentChange} value={getDevComponentState()}>
                    <Radio
                        value="RecurringPlanBanner"
                        label="Onboarding banner for recurring workplan"
                    />
                    <Radio value="None" label="None" />
                </RadioGroup>
            </Field>
            <Divider />
            <Title3>Explore API Error State</Title3>
            <Field label="Service to fail">
                <RadioGroup onChange={onErrorPageStateChange} value={getDevErrorPageState()}>
                    <Radio value="UserFWH" label="Fetching user's flexible working hours" />
                    <Radio value="Collaborators" label="Fetching the user's collaborators" />
                    <Radio value="Schedule" label="Fetching collaborators schedules" />
                    <Radio value="Places" label="Fetching all the places in the tenant" />
                    <Radio value="Place" label="Fetching a single place" />
                    <Radio value="Events" label="Fetching events" />
                    <Radio value="ErrorLoadingUpsLocation" label="Error loading UPS Location" />
                    <Radio value="ErrorSettingUpsLocation" label="Error setting UPS Location" />
                    <Radio value="None" label="None" />
                </RadioGroup>
            </Field>
            <Button appearance="primary" onClick={reload}>
                Re-Load
            </Button>
        </div>
    );
}, 'PlacesExploreDiagnosticsPanel');
